import { render, staticRenderFns } from "./product-card-information.vue?vue&type=template&id=53facf6a"
import script from "./product-card-information.vue?vue&type=script&lang=js"
export * from "./product-card-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseLink.vue').default})
